/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { styled } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import 'hammerjs'

// TODO: Don't use kendo, we will use Apexcharts
import {
  Chart,
  ChartArea,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTooltip,
  ChartValueAxis,
  ChartValueAxisItem,
} from '@progress/kendo-react-charts'

import actionTypes from 'store/actions'
import ConnectButton from 'components/Common/Button/ConnectButton'
import DaySpan from 'components/Common/DaySpan'
import SectionTitle from 'components/Common/SectionTitle'
import ToolTip from 'components/Common/ToolTip'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'

import { LinkOffIcon } from 'assets'
import cashflowPlaceholderSvg from 'assets/cashflow-img.svg'
import api from 'api'

const CardHeader = styled(Box)(() => ({
  width: '100%',
  height: '30px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

const CardBody = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const ChartPlaceholder = styled(Box)({
  position: 'relative',
  height: 'calc(100% - 50px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
})

const CashFlowCard = () => {
  const dispatch = useDispatch()

  const accountCodatConnected = useSelector(state => state.appReducer.accountCodatConnected)

  const daySpanSelected = useSelector(state => state.appReducer.financialOverviewDaySpan)
  //NOTE: Just for demo
  // const companyId = 'ffc4ec47-8d5a-4704-ac1a-b5f1f1b82f64'

  const seriesStyle = `smooth`

  // const loadingCashflowChartData = useSelector(state => state.apiResponseReducers.loadingCashflowChartData)

  const formattedChartData = [
    { timestamp: 'Jan', business_match: 0.85, business_no_match: 0.15 },
    { timestamp: 'Feb', business_match: 0.87, business_no_match: 0.13 },
    { timestamp: 'Mar', business_match: 0.89, business_no_match: 0.11 },
    { timestamp: 'Apr', business_match: 0.86, business_no_match: 0.14 },
    { timestamp: 'May', business_match: 0.88, business_no_match: 0.12 },
    { timestamp: 'Jun', business_match: 0.9, business_no_match: 0.1 },
    { timestamp: 'Jul', business_match: 0.89, business_no_match: 0.11 },
    { timestamp: 'Aug', business_match: 0.87, business_no_match: 0.13 },
    { timestamp: 'Sep', business_match: 0.85, business_no_match: 0.15 },
    { timestamp: 'Oct', business_match: 0.88, business_no_match: 0.12 },
    { timestamp: 'Nov', business_match: 0.9, business_no_match: 0.1 },
    { timestamp: 'Dec', business_match: 0.89, business_no_match: 0.11 },
  ]

  useEffect(() => {
    if (accountCodatConnected) {
      // GET CODAT CONNECT INFO FOR USER
      api.getCodatConnectUserInfo()
    }
  }, [accountCodatConnected])

  const onDaySpanClicked = async days => {
    dispatch({ type: actionTypes.SETFINANCIALOVERVIEWDAYSPAN, data: days })
  }

  const tooltipContent = (
    <Typography variant="body2" color="white">
      Business Verification Rates.
    </Typography>
  )

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          padding: '25px',
        }}
      >
        <CardHeader>
          <Box>
            <SectionTitle title="Business Verification Rates" />
            &nbsp;
            <ToolTip content={tooltipContent} />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <DaySpan onClick={onDaySpanClicked} daySpanSelected={daySpanSelected} />
            {accountCodatConnected && (
              <ButtonTooltip placement={'top'} title={'Disconnect App'} arrow>
                <LinkOffIcon style={{ cursor: 'pointer', marginLeft: '20px' }} />
              </ButtonTooltip>
            )}
          </Box>
        </CardHeader>
        {accountCodatConnected && (
          <CardBody>
            <ChartPlaceholder>
              <img src={cashflowPlaceholderSvg} style={{ width: '100%', height: '100%' }} alt="Cashflow-Placeholder" />
            </ChartPlaceholder>

            {<ConnectButton label="Connect your accounting app" />}
          </CardBody>
        )}

        {!accountCodatConnected && (
          <CardBody>
            <Chart
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              <ChartLegend position="bottom" spacing={40} />
              <ChartTooltip />
              <ChartArea background={'transparent'} />
              <ChartAxisDefaults
                line={{
                  color: 'grey',
                }}
                minorGridLines={{
                  visible: false,
                }}
                majorGridLines={{
                  visible: false,
                }}
                visible={true}
              />
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    format: 'p0',
                  }}
                />
              </ChartValueAxis>
              <ChartCategoryAxis>
                <ChartCategoryAxisItem baseUnits={'days'} majorGridLines={{ visible: true }} maxDivisions={10} />
              </ChartCategoryAxis>
              <ChartLegend position="bottom" labels={{ color: '#25245F' }} />
              <ChartSeries>
                <ChartSeriesItem
                  type="line"
                  name={'Business Match'}
                  style={seriesStyle}
                  data={formattedChartData}
                  field="business_match"
                  categoryField="timestamp"
                  color="#469CF8"
                  markers={{ visible: false }}
                >
                  <ChartSeriesItemTooltip background="#469CF8" format="p0" />
                </ChartSeriesItem>
                <ChartSeriesItem
                  type="line"
                  name={'Business No Match'}
                  style={seriesStyle}
                  data={formattedChartData}
                  field="business_no_match"
                  categoryField="timestamp"
                  color="#00CBA9"
                  markers={{ visible: false }}
                >
                  <ChartSeriesItemTooltip background="#00CBA9" format="p0" />
                </ChartSeriesItem>
              </ChartSeries>
            </Chart>
          </CardBody>
        )}
      </Box>
    </Box>
  )
}

export default CashFlowCard
